/* eslint-disable */

/**
=========================================================
* Material Dashboard 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2022 Drivers Portal (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

// Material Dashboard 2 React example components
import Footer from "examples/Footer";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

import { LoadingOutlined, PlusOutlined } from '@ant-design/icons';
import { Button, Col, Form, Input, InputNumber, Row, Select, Steps, Upload, notification } from "antd";
import { _add_admin, _add_driver, _add_merchants_user, _change_admin_status, _change_merchant_status, _get_admin, _get_admins, _get_merchant_user, _get_merchants_settings, _get_profile, _get_roles_byusertype, _update_merchant } from "common/axios_services";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

function AddDriver() {
    const navigate = useNavigate()
    const [form] = Form.useForm();
    const [creatingUser, setCreatingUser] = useState(false);
    const [step, setStep] = useState(0);
    const [personalInfo, setPersonalInfo] = useState({});
    const [driverInfo, setDriverInfo] = useState({});
    const [businessInfo, setBusinessInfo] = useState({});
    const [updateCount, setUpdateCount] = useState(0);
    const [profileImageUrl, setProfileImageUrl] = useState(null);
    const [idImageUrl, setIdImageUrl] = useState(null);
    const [driverImageUrl, setDriverImageUrl] = useState(null);
    const [vehicleImage, setVehicleImage] = useState(null);
    const [loading, setLoading] = useState(false);
    const [roles, setRoles] = useState([]);
    const [merchantsList, setMerchantsList] = useState([]);

    const openNotificationWithIcon = (type, message) => {
        notification[type]({
            message: '',
            placement: 'bottomRight',
            description:
                message,
        });
    };

    const fetchMerchantsRoles = async () => {
        try {
            const fetch_role = await _get_roles_byusertype({ type: "merchant" })
            setRoles(fetch_role.data.data);
        } catch (err) {
            if (err.response) {
                openNotificationWithIcon('error', err.response.data.message);
            } else {
                openNotificationWithIcon('error', err.message);
            }
        }
    }

    const getBase64 = (img, callback) => {
        const reader = new FileReader();
        reader.readAsDataURL(img);
        reader.addEventListener('load', () => callback(reader.result));
    }

    const handleChange = info => {
        getBase64(info.file.originFileObj, imageUrl =>
            setIdImageUrl(imageUrl),
            setLoading(false),
        );
        const reader = new FileReader();

        reader.readAsDataURL(info.file.originFileObj);
        reader.addEventListener('load', () => {
            form.setFieldsValue({ id_card_image: reader.result });
        });
    }

    const vehicleImageChange = info => {
        getBase64(info.file.originFileObj, imageUrl =>
            setVehicleImage(imageUrl),
            setLoading(false),
        );
        const reader = new FileReader();

        reader.readAsDataURL(info.file.originFileObj);
        reader.addEventListener('load', () => {
            form.setFieldsValue({ vehicle_image: reader.result });
        });
    }

    const profileChange = info => {
        getBase64(info.file.originFileObj, imageUrl =>
            setProfileImageUrl(imageUrl),
            setLoading(false),
        );
        const reader = new FileReader();

        reader.readAsDataURL(info.file.originFileObj);
        reader.addEventListener('load', () => {
            form.setFieldsValue({ image: reader.result });
        });
    }

    const driverImage = info => {
        getBase64(info.file.originFileObj, imageUrl =>
            setDriverImageUrl(imageUrl),
            setLoading(false),
        );
        const reader = new FileReader();

        reader.readAsDataURL(info.file.originFileObj);
        reader.addEventListener('load', () => {
            form.setFieldsValue({ driver_license_image: reader.result });
        });
    }

    const uploadButton = (
        <div>
            {loading ? <LoadingOutlined /> : <PlusOutlined />}
            <div style={{ marginTop: 8 }}>Upload</div>
        </div>
    );

    const finishPersonal = (values) => {
        setStep(1)
        setPersonalInfo(values)
    }
    const finishVehicle = async (values) => {
        const data = {
            number: `${values.vehicle_number}`,
            color: `${values.vehicle_color}`,
            brand: `${values.vehicle_brand}`,
            type: `${values.vehicle_type}`,
            weight: `${values.vehicle_capacity}`,
            vehicel_image: `${values.vehicle_image}`,
            merchant_id: businessInfo.merchant_id,
            id_card_no: `${businessInfo.id_card_no}`,
            id_card_image: businessInfo.id_card_image,
            about: businessInfo.about,
            location: businessInfo.location,
            first_name: personalInfo.first_name,
            last_name: personalInfo.last_name,
            email: personalInfo.email,
            image: personalInfo.image,
            phone_number: `0${personalInfo.phone_number}`,
            gender: personalInfo.gender,
            home_address: personalInfo.home_address,
            state_of_residence: personalInfo.state_of_residence,
            country: personalInfo.country,
            lga: personalInfo.lga,
            nin: `${personalInfo.nin}`,
            user_pin: `${personalInfo.user_pin}`,
            driver_license_no: `${driverInfo.driver_license_no}`,
            driver_license_image: `${driverInfo.driver_license_image}`,
            year_of_experience: `${driverInfo.year_of_experience}`
        }
        setCreatingUser(true);
        try {
            const create_user = await _add_driver(data)
            openNotificationWithIcon('success', create_user.data.message);
            setUpdateCount(updateCount + 1)
            setCreatingUser(false);
            navigate('/drivers')
        } catch (err) {
            setCreatingUser(false);
            if (err.response) {
                openNotificationWithIcon('error', err.response.data.message);
            } else {
                openNotificationWithIcon('error', err.message);
            }
        }
    }

    const finishBusiness = async (values) => {
        setStep(3)
        setBusinessInfo(values)
    }
    const finishDriver = (values) => {
        setStep(2)
        setDriverInfo(values)
    }
    const fetchMerchants = async () => {
        try {
            const fetch_merchant = await _get_merchants_settings({ page: "1", page_size: "10", search: "", category: "" })
            setMerchantsList(fetch_merchant.data.data);
        } catch (err) {
            if (err.response) {
                openNotificationWithIcon('error', err.response.data.message);
            } else {
                openNotificationWithIcon('error', err.message);
            }
        }
    }

    useEffect(() => {
        fetchMerchants()
        fetchMerchantsRoles()
    }, [])


    return (
        <DashboardLayout>
            <DashboardNavbar />
            <MDBox pt={6} pb={3}>
                <Grid container spacing={6}>
                    <Grid item xs={12}>
                        <Card>
                            <MDBox mx={2} mt={-3} py={3} px={2} variant="gradient" bgColor="info" borderRadius="lg" coloredShadow="info">
                                <MDTypography variant="h6" color="white">
                                    Add New Driver
                                </MDTypography>
                            </MDBox>
                            <MDBox pt={3} px={2}>
                                <>
                                    <Steps direction="horizontal" className='my-2' size="small" current={step} items={[
                                        {
                                            title: 'Personal',
                                        },
                                        {
                                            title: 'Driver',
                                        },
                                        {
                                            title: 'Business',
                                        },
                                        {
                                            title: 'Vehicle',
                                        },
                                    ]} />
                                    {step === 0 &&
                                        <Form layout="vertical" form={form} onFinish={finishPersonal} initialValues={{
                                            first_name: "",
                                            last_name: "",
                                            email: "",
                                            image: "",
                                            phone_number: "",
                                            gender: "",
                                            home_address: "",
                                            state_of_residence: "",
                                            country: "",
                                            lga: "",
                                            nin: "",
                                            user_pin: ""
                                        }}>
                                            <Form.Item name="image" label="Profile Image" >
                                                <Upload name="avatar" listType="picture-card" className="avatar-uploader" showUploadList={false} multiple={false} onChange={profileChange} >
                                                    {profileImageUrl ? <img src={profileImageUrl} alt="avatar" style={{ width: "130px" }} /> : uploadButton}
                                                </Upload>
                                            </Form.Item>
                                            <Row gutter={[16, 16]}>
                                                <Col xs={24} md={12}>
                                                    <Form.Item name="first_name" label="First Name">
                                                        <Input placeholder="First Name" />
                                                    </Form.Item>
                                                </Col>
                                                <Col xs={24} md={12}>
                                                    <Form.Item name="last_name" label="Last Name">
                                                        <Input placeholder="Last Name" />
                                                    </Form.Item>
                                                </Col>
                                            </Row>
                                            <Row gutter={[16, 16]}>
                                                <Col xs={24} md={12}>
                                                    <Form.Item name="email" label="Email">
                                                        <Input placeholder="Email" />
                                                    </Form.Item>
                                                </Col>
                                                <Col xs={24} md={12}>
                                                    <Form.Item name="phone_number" label="Phone Number">
                                                        <InputNumber style={{ width: "100%" }} placeholder="Phone Number" />
                                                    </Form.Item>
                                                </Col>
                                            </Row>
                                            <Row gutter={[16, 16]}>
                                                <Col xs={24} md={12}>
                                                    <Form.Item name="gender" label="Gender">
                                                        <Select placeholder="Select Gender">
                                                            <Select.Option value="male">Male</Select.Option>
                                                            <Select.Option value="female">Female</Select.Option>
                                                        </Select>
                                                    </Form.Item>
                                                </Col>
                                                <Col xs={24} md={12}>
                                                    <Form.Item name="home_address" label="Home Address">
                                                        <Input placeholder="Home Address" />
                                                    </Form.Item>
                                                </Col>
                                            </Row>
                                            <Row gutter={[16, 16]}>
                                                <Col xs={24} md={12}>
                                                    <Form.Item name="country" label="Country">
                                                        <Input placeholder="Country" />
                                                    </Form.Item>
                                                </Col>
                                                <Col xs={24} md={12}>
                                                    <Form.Item name="state_of_residence" label="State Of Residence">
                                                        <Input placeholder="State Of Residence" />
                                                    </Form.Item>
                                                </Col>
                                            </Row>
                                            <Row gutter={[16, 16]}>
                                                <Col xs={24} md={12}>
                                                    <Form.Item name="lga" label="LGA">
                                                        <Input style={{ width: "100%" }} placeholder="LGA" />
                                                    </Form.Item>
                                                </Col>
                                                <Col xs={24} md={12}>
                                                    <Form.Item name="nin" label="NIN">
                                                        <InputNumber style={{ width: "100%" }} placeholder="Nin" />
                                                    </Form.Item>
                                                </Col>
                                            </Row>
                                            <Row gutter={[16, 16]}>
                                                <Col xs={24} md={12}>
                                                    <Form.Item label="User Pin" name="user_pin">
                                                        <Input.Password style={{ padding: "10px 20px" }} placeholder="User Pin" />
                                                    </Form.Item>
                                                </Col>
                                            </Row>
                                            <div style={{ display: "flex", justifyContent: "space-between" }}>
                                                <div></div>
                                                <Form.Item>
                                                    {creatingUser ? (
                                                        <Button type="primary" loading>Loading</Button>
                                                    ) :
                                                        <Button type="primary" htmlType="submit">Proceed</Button>
                                                    }
                                                </Form.Item>
                                            </div>
                                        </Form>
                                    }
                                    {step === 1 &&
                                        <Form layout="vertical" form={form} onFinish={finishDriver} initialValues={{
                                            driver_license_no: "",
                                            driver_license_image: "",
                                            year_of_experience: ""
                                        }}>
                                            <Form.Item name="driver_license_image" label="Driver License Image" >
                                                <Upload name="avatar" listType="picture-card" className="avatar-uploader" showUploadList={false} multiple={false} onChange={driverImage} >
                                                    {driverImageUrl ? <img src={driverImageUrl} alt="avatar" style={{ width: "130px" }} /> : uploadButton}
                                                </Upload>
                                            </Form.Item>
                                            <Row gutter={[16, 16]}>
                                                <Col xs={24} md={12}>
                                                    <Form.Item name="driver_license_no" label="Driver License Number">
                                                        <InputNumber style={{ width: "100%" }} placeholder="Driver License Number" />
                                                    </Form.Item>
                                                </Col>
                                                <Col xs={24} md={12}>
                                                    <Form.Item name="year_of_experience" label="Year of experience">
                                                        <InputNumber style={{ width: "100%" }} placeholder="Year of experience" />
                                                    </Form.Item>
                                                </Col>
                                            </Row>
                                            <div style={{ display: "flex", justifyContent: "space-between" }}>
                                                <Button onClick={() => setStep(0)}>Back</Button>
                                                <Form.Item>
                                                    {creatingUser ? (
                                                        <Button type="primary" loading>Loading</Button>
                                                    ) :
                                                        <Button type="primary" htmlType="submit">Proceed</Button>
                                                    }
                                                </Form.Item>
                                            </div>
                                        </Form>
                                    }
                                    {step === 2 &&
                                        <Form layout="vertical" form={form} onFinish={finishBusiness} initialValues={{
                                            merchant_id: "",
                                            id_card_no: "",
                                            id_card_image: "",
                                            about: "",
                                            location: "",
                                        }}>
                                            <Form.Item name="id_card_image" label="ID Card Image" >
                                                <Upload name="avatar" listType="picture-card" className="avatar-uploader" showUploadList={false} multiple={false} onChange={handleChange} >
                                                    {idImageUrl ? <img src={idImageUrl} alt="avatar" style={{ width: "130px" }} /> : uploadButton}
                                                </Upload>
                                            </Form.Item>
                                            <Row gutter={[16, 16]}>
                                                <Col xs={24} md={12}>
                                                    <Form.Item name="id_card_no" label="Id Card Number">
                                                        <InputNumber style={{ width: "100%" }} placeholder="Id Card Number" />
                                                    </Form.Item>
                                                </Col>
                                                <Col xs={24} md={12}>
                                                    <Form.Item name="location" label="Office Address">
                                                        <Input placeholder="Office Address" />
                                                    </Form.Item>
                                                </Col>
                                            </Row>
                                            <Row gutter={[16, 16]}>
                                                <Col xs={24} md={12}>
                                                    <Form.Item name="merchant_id" label="Merchant">
                                                        <Select placeholder="Select Merchant">
                                                            {merchantsList.map((merchant, index) => (
                                                                <Select.Option key={index} value={merchant.id}>{merchant.name}</Select.Option>
                                                            ))}
                                                        </Select>
                                                    </Form.Item>
                                                </Col>
                                                <Col xs={24} md={12}>
                                                    <Form.Item name="about" label="About">
                                                        <Input style={{ width: "100%" }} placeholder="About" />
                                                    </Form.Item>
                                                </Col>
                                            </Row>
                                            <div style={{ display: "flex", justifyContent: "space-between" }}>
                                                <Button onClick={() => setStep(1)}>Back</Button>
                                                <Form.Item>
                                                    {creatingUser ? (
                                                        <Button type="primary" loading>Loading</Button>
                                                    ) :
                                                        <Button type="primary" htmlType="submit">Proceed</Button>
                                                    }
                                                </Form.Item>
                                            </div>
                                        </Form>
                                    }
                                    {step === 3 &&
                                        <Form layout="vertical" form={form} onFinish={finishVehicle} initialValues={{
                                            vehicle_number: "",
                                            vehicle_color: "",
                                            vehicle_brand: "",
                                            vehicle_type: "",
                                            vehicle_capacity: "",
                                        }}>
                                            <Form.Item name="vehicle_image" label="Vehicle Image" >
                                                <Upload name="avatar" listType="picture-card" className="avatar-uploader" showUploadList={false} multiple={false} onChange={vehicleImageChange} >
                                                    {vehicleImage ? <img src={vehicleImage} alt="avatar" style={{ width: "130px" }} /> : uploadButton}
                                                </Upload>
                                            </Form.Item>
                                            <Row gutter={[16, 16]}>
                                                <Col xs={24} md={12}>
                                                    <Form.Item name="vehicle_number" label="Vehicle Number">
                                                        <InputNumber style={{ width: "100%" }} placeholder="Vehicle Number" />
                                                    </Form.Item>
                                                </Col>
                                                <Col xs={24} md={12}>
                                                    <Form.Item name="vehicle_color" label="Vehicle Color">
                                                        <Input placeholder="Vehicle Color" />
                                                    </Form.Item>
                                                </Col>
                                            </Row>
                                            <Row gutter={[16, 16]}>
                                                <Col xs={24} md={12}>
                                                    <Form.Item name="vehicle_brand" label="Vehicle Brand">
                                                        <Input placeholder="Vehicle Brand" />
                                                    </Form.Item>
                                                </Col>
                                                <Col xs={24} md={12}>
                                                    <Form.Item name="vehicle_type" label="Vehicle Type">
                                                        <Input style={{ width: "100%" }} placeholder="Vehicle Type" />
                                                    </Form.Item>
                                                </Col>
                                            </Row>
                                            <Row gutter={[16, 16]}>
                                                <Col xs={24} md={12}>
                                                    <Form.Item name="vehicle_capacity" label="Vehicle Capacity (KG)">
                                                        <InputNumber placeholder="Vehicle Capacity (KG)" />
                                                    </Form.Item>
                                                </Col>
                                            </Row>
                                            <div style={{ display: "flex", justifyContent: "space-between" }}>
                                                <Button onClick={() => setStep(2)}>Back</Button>
                                                <Form.Item>
                                                    {creatingUser ? (
                                                        <Button type="primary" loading>Loading</Button>
                                                    ) :
                                                        <Button type="primary" htmlType="submit">Proceed</Button>
                                                    }
                                                </Form.Item>
                                            </div>
                                        </Form>
                                    }
                                </>
                            </MDBox>
                        </Card>
                    </Grid>
                </Grid>
            </MDBox>
            <Footer />
        </DashboardLayout>
    );
}

export default AddDriver;